<!--The main content below -->

<!-- [ngClass]="{'nonlogin': !sidebarStatus}" -->
<div class="wrapper">
    <app-header (loginEmitter)="myEmitter($event)"></app-header>
    <div class="main-wrapper closemenu" id="mainwrapper">
        <!-- <app-sidebar *ngIf="sidebarVisible" class="sidebar sidebarHover toggled" id="accordionSidebar"></app-sidebar> -->
        <app-sidebar-isdp *ngIf="sidebarVisible" class="sidebar sidebarHover toggled" id="accordionSidebar"></app-sidebar-isdp>
        <div class="d-flex flex-column" id="{{ sidebarVisible ? 'content-wrapper' : 'content-wrapper_N' }}">
            <div id="content">
             <app-loader></app-loader>
            <router-outlet></router-outlet>
        </div>
        <app-footer *ngIf="ClientType != ConstantClient" (loginEmitter)="myEmitter($event)"></app-footer>
        <app-footer-second *ngIf="ClientType == ConstantClient" (loginEmitter)="myEmitter($event)"></app-footer-second>
    </div>
</div>
</div>
